// Machine-translated — pending native review.
const zh: Record<string, string> = {
  // ── App ──────────────────────────────────────────────────────────────────
  'app.title': 'XTM Express',

  // ── Login ────────────────────────────────────────────────────────────────
  'login.title': 'XTM Express',
  'login.subtitle': '企业级 AI 翻译门户',
  'login.description': '使用您的企业凭据登录，开始翻译文档',
  'login.ssoButton': '使用 SSO 登录',
  'login.footer': '由 Zitadel 提供安全保障 · OAuth 2.1',

  // ── Header ───────────────────────────────────────────────────────────────
  'header.title': 'XTM Express',
  'header.avatarLabel': '用户菜单',
  'header.languageLabel': '选择语言',

  // ── Stepper ──────────────────────────────────────────────────────────────
  'stepper.upload': '上传',
  'stepper.analyze': '分析',
  'stepper.translate': '翻译',

  // ── Upload Page ──────────────────────────────────────────────────────────
  'upload.title': '上传您的内容',
  'upload.tab.file': '上传文件',
  'upload.tab.text': '输入文本',
  'upload.text.placeholder': '粘贴或输入要翻译的文本……',
  'upload.text.charCount': '{count} / {max} 个字符',
  'upload.text.tooLong': '文本超过 {max} 个字符的上限，请缩短。',
  'upload.dropzone.title': '将文件拖放到此处',
  'upload.dropzone.or': '或',
  'upload.dropzone.browse': '浏览文件',
  'upload.dropzone.formats': '支持 {formats} 格式 · 最多 5 个文件 · 每个文件 10 MB',
  'upload.sourceLanguage': '源语言',
  'upload.sourceLanguage.placeholder': '选择源语言……',
  'upload.targetLanguages': '目标语言',
  'upload.targetLanguages.placeholder': '搜索并选择目标语言……',
  'upload.targetLanguages.selected': '已选择 {count} 种语言',
  'languagePicker.loading': '正在加载语言……',
  'languagePicker.loadError': '无法加载语言列表。',
  'languagePicker.retry': '重试',
  'languagePicker.noMatch': '没有与“{query}”匹配的语言或变体。',
  'languagePicker.regionalVariants': '地区变体',
  'languagePicker.showMore': '显示 {language} 的另外 {count} 个变体',
  'languagePicker.default': '默认',
  'languagePicker.variantCount': '{count} 个变体',
  'languagePicker.languageOption': '{language}，{count} 个变体，已选 {selected} 个',
  'languagePicker.showVariants': '显示 {language} 变体',
  'languagePicker.hideVariants': '隐藏 {language} 变体',
  'languagePicker.remove': '移除 {name}',
  'languagePicker.changeVariant': '更改 {language} 变体',
  'languagePicker.changeVariantOf': '更改 {name} 的变体',
  'languagePicker.searchVariants': '搜索 {count} 个变体……',
  'languagePicker.searchVariantsOf': '搜索 {language} 变体',
  'languagePicker.noVariantMatch': '没有匹配的变体。',
  'languagePicker.allVariants': '全部变体',
  'languagePicker.added': '已添加',
  'languagePicker.keys.move': '移动',
  'languagePicker.keys.toggle': '选择 / 取消选择',
  'languagePicker.keys.expand': '显示变体',
  'languagePicker.keys.collapse': '隐藏变体',
  'languagePicker.keys.clear': '清除搜索',
  'upload.files.summary': '已上传 {count} 个文件 · {size}',
  'upload.files.column.name': '文件',
  'upload.files.column.size': '大小',
  'upload.files.column.actions': '',
  'upload.files.remove': '移除文件',
  'upload.files.addMore': '添加更多文件',
  'upload.analyzeButton': '分析内容',
  'upload.maxFiles': '您最多可以上传 5 个文件。部分文件未被添加。',
  'upload.error.unsupportedType': '“{name}”不是受支持的格式，未被添加。支持的格式：{formats}',
  'upload.error.zipTooMany': '“{name}”包含 {count} 个文件。一个 zip 最多可包含 5 个文件。',
  'upload.uploading': '正在上传文件……',
  'upload.error': '上传失败。请重试。',
  'upload.error.tooLarge': '文件“{name}”超过 {max} 的上传限制。请选择较小的文件。',

  // ── Analysis Page ────────────────────────────────────────────────────────
  'analysis.title': 'AI 风险分析',
  'analysis.subtitle': '我们的 AI 引擎已评估每个文件的翻译复杂度和合规风险。请检查每个文件的建议通道，然后接受建议或选择另一个通道。',
  'analysis.risk.high': '高风险',
  'analysis.risk.low': '低风险',
  'analysis.risk.high.tooltip': '敏感、复杂或对业务至关重要的内容，翻译错误会带来实际风险。将转交专业人工审校。',
  'analysis.risk.low.tooltip': 'AI 引擎可独立可靠翻译的简单内容。即时翻译，可立即下载。',
  'analysis.risk.borderline': '接近边界',
  'analysis.risk.failed': '分析失败',
  'analysis.risk.failed.tooltip': '此文件的 AI 风险分析失败，因此未确定风险等级。作为安全措施，建议使用“以人为中心”，由专业语言专家处理该文件。',
  'analysis.risk.failed.message': '风险分析失败 — 作为安全措施，建议使用“以人为中心”。',
  'analysis.failedBanner': '{count, plural, one {# 个文件} other {# 个文件}} 的风险分析失败。请确认 LLM 连接正确，然后重新上传文件或重新输入文本。',
  'analysis.risk.failed.message.timedOut': '风险分析未在 {minutes, plural, one {# 分钟} other {# 分钟}}内完成，因此未确定风险等级。作为安全措施，建议使用“以人为中心”。',
  'analysis.risk.failed.message.timedOutNoLimit': '风险分析未及时完成，因此未确定风险等级。作为安全措施，建议使用“以人为中心”。',
  'analysis.risk.failed.message.assessmentFailed': '风险分析服务无法评估此文件，因此未确定风险等级。作为安全措施，建议使用“以人为中心”。',
  'analysis.risk.failed.message.noLlmConnector': '您的组织未设置 LLM 连接，因此未评估此文件。作为安全措施，建议使用“以人为中心”。',
  'analysis.failedBanner.timedOut': '{count, plural, one {# 个文件} other {# 个文件}} 的风险分析未及时完成。作为安全措施，建议使用“以人为中心”；您仍可选择 AI-Direct。',
  'analysis.unreadable.badge': '无法读取文件',
  'analysis.unreadable.message': '<b>XTM Go 无法解析此文件</b>，因此未进行评估，也无法翻译。',
  'analysis.unreadable.remove': '从批次中移除',
  'analysis.unreadable.remove.aria': '从批次中移除 {filename}',
  'analysis.unreadable.removed': '已从批次中移除，不会被翻译。',
  'analysis.unreadable.undo': '撤销',
  'analysis.unreadable.undo.aria': '撤销移除 {filename}',
  'analysis.unreadable.banner.single': '<b>无法读取此文件，因此无法翻译。</b>请修复文件后开始新的翻译。',
  'analysis.unreadable.banner.all': '<b>{count} 个文件均无法读取，因此没有可翻译的内容。</b>请修复文件后开始新的翻译。',
  'analysis.unreadable.banner.some': '<b>{count} 个文件无法读取，因此此批次暂时无法翻译。</b>从批次中移除这 {count} 个文件后即可翻译其余 {others} 个文件。',
  'analysis.translateButton.removeFailed': '移除 {count} 个失败的文件后翻译',
  'analysis.announce.removeFirst': '翻译前请移除 {count} 个无法读取的文件。',
  'analysis.announce.removed': '已从批次中移除 {filename}，不会被翻译。',
  'analysis.announce.restored': '{filename} 已重新加入批次。包含该文件时无法翻译此批次。',
  'analysis.route.aiDirect': 'AI-Direct',
  'analysis.route.xtmCloud': '以人为中心',
  'analysis.route.aiDirect.tooltip': '由 AI 即时翻译，几分钟内即可下载。建议用于低风险内容。',
  'analysis.route.xtmCloud.tooltip': '交付前由专业人工审校人员进行审核。建议用于高风险或复杂内容。',
  'analysis.translateButton': '翻译',
  'analysis.translateButton.files': '翻译 {count} 个文件',
  'analysis.translateButton.decideMore': '还需决定 {count} 个才能翻译',
  'analysis.translateButton.decideSingle': '接受或更改通道后即可翻译',
  'analysis.risk.borderline.hint': '<b>接近边界：</b>分数接近低风险与高风险的分界线，因此建议也可能相反。请仔细检查此文件。',
  'analysis.suggestion.label': 'AI 建议',
  'analysis.suggestion.labelFailSafe': '安全措施建议',
  'analysis.decision.accept': '接受建议',
  'analysis.decision.accept.aria': '接受 {filename} 的建议',
  'analysis.decision.useOther': '改用 {lane}',
  'analysis.decision.useOther.aria': '为 {filename} 改用 {lane}',
  'analysis.decision.accepted': '已接受：<b>{lane}</b>',
  'analysis.decision.changed': '已改为 <b>{lane}</b>（AI 建议：{suggested}）',
  'analysis.decision.changedFailSafe': '已改为 <b>{lane}</b>（安全措施建议：{suggested}）',
  'analysis.decision.change': '更改',
  'analysis.decision.change.aria': '更改 {filename} 的决定',
  'analysis.decision.acceptAll': '接受所有剩余建议',
  'analysis.styleGuide.label': '风格指南',
  'analysis.languagePair.aria': '从 {source} 翻译为 {targets}',
  'analysis.languagePair.noSource.aria': '翻译为 {targets}',
  'analysis.styleGuide.choose.aria': '{filename} 的风格指南：{name}',
  'analysis.styleGuide.popup.aria': '选择风格指南',
  'analysis.styleGuide.default': '默认',
  'analysis.styleGuide.none': '不使用风格指南',
  'analysis.styleGuide.none.description': '翻译此文件时不使用风格指南。',
  'analysis.styleGuide.search': '按名称或语言代码搜索',
  'analysis.styleGuide.search.aria': '搜索风格指南',
  'analysis.styleGuide.noMatch': '没有与“{query}”匹配的风格指南。',
  'analysis.styleGuide.updated': '更新于 {date}',
  'analysis.styleGuide.help.default': '使用翻译开始时贵组织的默认风格指南。',
  'analysis.styleGuide.help.none': '此文件将在不使用风格指南的情况下翻译。贵组织的默认风格指南是 <b>{name}</b>。',
  'analysis.styleGuide.help.noneNoDefault': '此文件将在不使用风格指南的情况下翻译。',
  'analysis.styleGuide.help.selected': '已从默认值（<b>{name}</b>）更改。适用于 {languages}。',
  'analysis.styleGuide.help.selectedNoDefault': '已从默认值（不使用风格指南）更改。适用于 {languages}。',
  'analysis.styleGuide.help.selectedNoLanguages': '已从默认值（<b>{name}</b>）更改。',
  'analysis.styleGuide.help.selectedNoDefaultNoLanguages': '已从默认值（不使用风格指南）更改。',
  'analysis.styleGuide.useDefault': '使用默认值',
  'analysis.styleGuide.loadFailed': '无法加载风格指南。此文件将使用贵组织的默认值。',
  'analysis.styleGuide.loading': '正在加载风格指南…',
  'analysis.styleGuide.refreshFailed': '无法刷新列表。您的选择已保留。',
  'analysis.xtmCloud.customer.label': 'XTM Cloud 客户',
  'analysis.xtmCloud.template.label': '项目模板',
  'analysis.xtmCloud.customer.choose.aria': '{filename} 的 XTM Cloud 客户：{name}',
  'analysis.xtmCloud.template.choose.aria': '{filename} 的项目模板：{name}',
  'analysis.xtmCloud.customer.popup.aria': '选择 XTM Cloud 客户',
  'analysis.xtmCloud.template.popup.aria': '选择项目模板',
  'analysis.xtmCloud.search': '按名称搜索',
  'analysis.xtmCloud.customer.search.aria': '搜索 XTM Cloud 客户',
  'analysis.xtmCloud.template.search.aria': '搜索项目模板',
  'analysis.xtmCloud.customer.noMatch': '没有与“{query}”匹配的客户。',
  'analysis.xtmCloud.template.noMatch': '没有与“{query}”匹配的模板。',
  'analysis.xtmCloud.default': '默认',
  'analysis.xtmCloud.customer.automatic': 'XTM Go（自动创建）',
  'analysis.xtmCloud.customer.unknown': '客户 {id}',
  'analysis.xtmCloud.template.none': '不使用模板',
  'analysis.xtmCloud.template.global': '全局',
  'analysis.xtmCloud.template.unknown': '模板 {id}',
  'analysis.xtmCloud.help.default': '使用将文件发送到 XTM Cloud 时贵组织的默认客户和模板。',
  'analysis.xtmCloud.help.selected': '已从默认值（<b>{customer}</b>、<b>{template}</b>）更改。',
  'analysis.xtmCloud.help.selectedAutomatic': '已从默认值更改：<b>XTM Go</b>，自动创建；<b>{template}</b>。',
  'analysis.xtmCloud.useDefault': '使用默认值',
  'analysis.xtmCloud.loading': '正在加载客户…',
  'analysis.xtmCloud.templates.loading': '正在加载模板…',
  'analysis.xtmCloud.loadFailed': '无法加载 XTM Cloud 客户。此文件将使用贵组织的默认客户和模板。',
  'analysis.xtmCloud.templates.loadFailed': '无法加载此客户的模板。',
  'analysis.xtmCloud.refreshFailed': '无法刷新列表。您的选择已保留。',
  'analysis.laneDecision.styleGuideGone': '为 {filename} 选择的风格指南已不存在。请选择其他风格指南。',
  'analysis.laneDecision.xtmCustomerGone': '为 {filename} 选择的 XTM Cloud 客户已不可用。请选择其他客户。',
  'analysis.laneDecision.xtmTemplateGone': '为 {filename} 选择的项目模板已不可用。请选择其他模板。',
  'analysis.laneDecision.xtmCloudUnavailable': 'XTM Go 无法连接 XTM Cloud，因此无法检查为 {filename} 选择的客户和模板。请重试。',
  'analysis.announce.accepted': '{filename}：已接受 {lane}。',
  'analysis.announce.changed': '{filename}：已改为 {lane}。',
  'analysis.announce.cleared': '{filename}：已清除决定。',
  'analysis.announce.acceptedAll': '已为 {count} 个文件接受 AI 建议。所有文件均已决定。',
  'analysis.announce.decideFirst': '请先为剩余 {count} 个文件决定通道。',
  'analysis.announce.decideFirstSingle': '请先接受或更改通道。',
  'analysis.backToUpload': '返回上传',
  'analysis.loading.hint': '这通常需要不到一分钟。您可以保持此标签页打开——我们会自动更新它。',
  'analysis.loading.status.STARTING': '正在开始……',
  'analysis.loading.status.PENDING_UPLOAD': '正在等待您的文档……',
  'analysis.loading.status.UPLOADING': '正在上传您的文档……',
  'analysis.loading.status.PARSING': '正在读取您的文档……',
  'analysis.loading.status.READY_FOR_ANALYSIS': '正在排队等待分析……',
  'analysis.loading.status.ANALYZING': '正在评估文档风险……',
  'analysis.loading.status.ANALYZED': '正在完成分析……',
  'analysis.loading.status.FETCHING_REPORT': '正在整理结果……',
  'analysis.polling.progress': '第 {current} 个文档，共 {total} 个',
  'analysis.error': '分析失败。请重试。',
  'analysis.retry': '重试',
  'analysis.laneDecision.submitting': '正在提交通道决策……',
  'analysis.laneDecision.error': '提交通道决策失败。请重试。',
  'analysis.deadline': '请在 {deadline} 之前选择通道。之后，已上传的文件将不再保留，需要重新上传。',
  'analysis.sourceExpired': '已上传的文件已不再保留，因此无法再翻译。请开始新的翻译并重新上传。',
  'analysis.sourceExpired.partial': '已上传的文件已不再保留，因此尚未发送的文件无法再翻译。已发送的文件将继续处理。',
  'analysis.sourceExpired.showSent': '查看已发送的文件',
  'analysis.startNew.confirmTitle': '放弃此翻译？',
  'analysis.startNew.confirmBody': '放弃此翻译并开始新的翻译？已上传的文件都不会被翻译。',
  'analysis.startNew.confirmButton': '放弃并重新开始',
  'analysis.startNew.cancel': '取消',
  'analysis.startNew.error': '无法开始新的翻译。请重试。',
  'analysis.noData': '没有可分析的文档。请返回并上传文件。',
  'analysis.riskReport.button': '风险报告',
  'analysis.riskReport.veto': '已触发否决',
  'analysis.riskReport.failed': '因素未通过',
  'analysis.riskReport.factor.criticalDownstreamImpactRisk': '关键下游影响',
  'analysis.riskReport.factor.structuralFormatIntegrityRisk': '结构 / 格式完整性',
  'analysis.riskReport.factor.domainDifficultyClassification': '领域难度',
  'analysis.riskReport.factor.referencelessTranslationDifficultyEstimation': '翻译难度',

  // ── Translate Page ───────────────────────────────────────────────────────
  'translate.progress.title': '正在翻译您的内容……',
  'translate.progress.info': '正在处理 {total} 个文档中的 {current} 个',
  'translate.progress.hint': '这通常需要几分钟。您可以保持此标签页打开——我们会自动更新它。',
  'translate.progress.stage.prepare': '正在为 AI 引擎准备您的内容……',
  'translate.progress.stage.context': '正在读取每个句段的上下文……',
  'translate.progress.stage.translate': '正在逐句翻译……',
  'translate.progress.stage.terminology': '正在保持术语和语气一致……',
  'translate.progress.stage.quality': '正在检查格式和结构……',
  'translate.complete.title': '处理完成',
  'translate.complete.filesReady': '{count, plural, one {# 个文件已} other {# 个文件已}}准备好下载。',
  'translate.complete.inReview': '{count, plural, one {已将 # 个文档} other {已将 # 个文档}}以“以人为中心”流程发送至 TMS。翻译后的文件可供下载后，我们会通过电子邮件通知您。',
  'translate.complete.expandAll': '全部展开',
  'translate.complete.collapseAll': '全部收起',
  'translate.complete.showLanguages': '显示 {document} 的已翻译文件',
  'translate.complete.hideLanguages': '隐藏 {document} 的已翻译文件',
  'translate.complete.fileCount': '{count, plural, other {# 个文件}}',
  'translate.complete.readyOf': '{total} 个中已完成 {ready} 个',
  'translate.complete.languagesNotDelivered': '{count, plural, other {# 种语言未交付。}}',
  'translate.complete.languagesWithWarning': '{count, plural, other {# 种语言已交付，但有警告。}}',
  'translate.partial.banner.title': '部分文档需要关注',
  'translate.partial.banner.description': '部分任务失败。您可以在下方重试失败的任务。',
  'translate.table.column.file': '文档',
  'translate.table.column.language': '语言',
  'translate.table.column.route': '通道',
  'translate.table.column.status': '状态',
  'translate.table.column.action': '操作',
  'translate.status.PENDING': '待处理',
  'translate.status.QUEUED': '已排队',
  'translate.status.PROCESSING': '处理中',
  'translate.status.GENERATING_TARGETS': '正在生成翻译',
  'translate.status.TRANSLATING': '翻译中',
  'translate.status.DELIVERING': '交付中',
  'translate.status.IN_PROGRESS': '进行中',
  'translate.status.COMPLETED': '已完成',
  'translate.status.FAILED': '失败',
  'translate.status.inReview': '人工审核中',
  'translate.status.sent': '已发送',
  'translate.action.download': '下载',
  'translate.action.viewInXtm': '查看审核',
  'translate.action.retry': '重试',
  'translate.action.downloading': '正在下载……',
  'translate.action.retrying': '正在重试……',
  'translate.action.retried': '已重试',
  'translate.action.downloadAll': '全部下载',
  'translate.action.downloadLanguage': '下载 {document}，{language}',
  'translate.action.downloaded': '已下载',
  'translate.newTranslation': '开始新的翻译',
  'translate.downloadAll': '全部下载为 ZIP',
  'translate.downloadCompleted': '下载已完成',
  'translate.loading': '正在准备翻译任务……',
  'translate.error': '翻译失败。请重试。',
  'translate.noJobs': '未找到翻译任务。请返回并提交通道决策。',
  'translate.failureReason': '原因：{reason}',
  'translate.retry.error': '重试失败，请再试一次。',
  'translate.retry.sourceExpired': '已上传的文件已不再保留，因此无法重试。请在新的翻译中重新上传。',

  // ── Languages ────────────────────────────────────────────────────────────
  'language.en': '英语',
  'language.fr': '法语',
  'language.de': '德语',
  'language.es': '西班牙语',
  'language.ja': '日语',
  'language.zh': '简体中文',
  'language.pt': '葡萄牙语',
  'language.it': '意大利语',
  'language.ko': '韩语',
  'language.ar': '阿拉伯语',
  'language.nl': '荷兰语',
  'language.pl': '波兰语',
  'language.sv': '瑞典语',
  'language.el': '希腊语',

  // ── Shared ───────────────────────────────────────────────────────────────
  'shared.loading': '加载中……',
  'shared.error.title': '出错了',
  'shared.error.description': '发生了意外错误。请尝试刷新页面。',
  'shared.error.retry': '重试',
  'shared.empty': '无可用数据',

  // ── Auth / Admin / Translated files (added in PR #7 merge) ──
  'header.home': 'XTM Go 主页',
  'header.signOut': '退出登录',
  'header.adminXtmCloud': '配置',
  'header.translatedFiles': '已翻译文件',
  'header.help': '帮助和资源',
  'header.help.documentation': '文档',
  'header.help.apiDocumentation': 'API 文档',
  'auth.callback.loading': '正在登录…',
  'accessDenied.title': '访问被拒绝',
  'accessDenied.body': '您已登录，但您的账户未获得访问 XTM Go 的权限。如果您认为这是错误，请联系您的管理员。',
  'admin.xtmCloud.title': '配置',
  'admin.xtmCloud.subtitle': '管理您的 XTM Cloud 集成和 AI 翻译设置。',
  'admin.xtmCloud.status.done': '已配置',
  'admin.xtmCloud.status.pending': '待处理',
  'admin.xtmCloud.overview.title': '设置概览',
  'admin.xtmCloud.nav.label': '配置分区',
  'admin.xtmCloud.nav.unsaved': '有未保存的更改',
  'admin.xtmCloud.customer.problem.authentication': 'XTM Cloud 拒绝了已保存的凭据，因此无法加载列表。请在上方更正并保存。',
  'admin.xtmCloud.customer.problem.unavailable': 'XTM Cloud 未响应，因此无法加载列表。已保存的凭据没有问题。',
  'admin.xtmCloud.nav.problem': 'XTM Cloud 连接不可用',
  'admin.xtmCloud.retry': '重试',
  'admin.xtmCloud.connector.title': 'LLM 连接器',
  'admin.xtmCloud.footer.unsaved': '未保存的更改',
  'admin.xtmCloud.footer.save': '保存更改',
  'admin.xtmCloud.footer.discard': '放弃',
  'admin.xtmCloud.loading': '正在加载配置…',
  'admin.xtmCloud.loadError': '无法加载 XTM Cloud 配置。',
  'admin.xtmCloud.connection.title': 'XTM Cloud 连接',
  'admin.xtmCloud.connection.description': '将 XTM Go 连接到贵组织的 XTM Cloud 账户，并为发送到“以人为中心”的文件选择默认客户和项目模板。基础 URL 来自贵组织的 SSO 设置，无法在此处更改。',
  'admin.xtmCloud.baseUrl': '基础 URL',
  'admin.xtmCloud.client': '客户端',
  'admin.xtmCloud.username': '用户名',
  'admin.xtmCloud.password': '密码',
  'admin.xtmCloud.passwordSet': '已设置密码',
  'admin.xtmCloud.passwordNotSet': '尚未设置密码',
  'admin.xtmCloud.saved': '更改已保存。',
  'admin.xtmCloud.credentialsError': '无法保存凭据。',
  'admin.xtmCloud.credentialsIncomplete': '保存凭据需要填写客户端、用户名和密码这三项。',
  'admin.xtmCloud.customer.locked': '请先保存凭据以加载客户。',
  'admin.xtmCloud.customer.label': '默认客户',
  'admin.xtmCloud.customer.select': '选择客户',
  'admin.xtmCloud.customer.loading': '正在加载客户…',
  'admin.xtmCloud.customer.unavailable': '此客户在 XTM Cloud 中已不再处于活动状态。请选择其他客户。',
  'admin.xtmCloud.customerError': '无法保存所选客户。',
  'admin.xtmCloud.template.select': '默认项目模板',
  'admin.xtmCloud.template.none': '不使用模板',
  'admin.xtmCloud.template.global': '全局',
  'admin.xtmCloud.template.locked': '请先选择客户，再选择其项目模板。',
  'admin.xtmCloud.template.loadFailed': '无法加载项目模板。',
  'admin.xtmCloud.template.unavailable': '此模板在 XTM Cloud 中已不存在。请选择其他模板。',
  'admin.xtmCloud.templateError': '无法保存项目模板。',
  'admin.xtmCloud.problem.authentication.title': 'XTM Cloud 拒绝了已保存的凭据',
  'admin.xtmCloud.problem.authentication.body': '请检查下方的客户端和用户名，然后重新输入密码并保存。XTM Cloud 不会返回已保存的密码，因此无法核对，只能替换。',
  'admin.xtmCloud.problem.unavailable.title': 'XTM Cloud 无响应',
  'admin.xtmCloud.problem.unavailable.body': '这是暂时的，已保存的凭据没有问题。请稍后重试，无需修改密码。',
  'admin.xtmCloud.problem.reference': '参考编号：{id}',
  'admin.xtmCloud.none': '—',
  'admin.xtmCloud.llm.description': '选择用于翻译的 AI 连接器。',
  'admin.xtmCloud.llm.riskAssessmentOverride': '此连接器也用于 AI 风险评估，并会覆盖其中配置的默认连接器。',
  'admin.xtmCloud.tools.riskAssessment': '风险评估',
  'admin.xtmCloud.tools.mtLlmGateway': 'XTM Gateway',
  'admin.xtmCloud.tools.newTab': '（在新标签页中打开）',
  'admin.xtmCloud.llm.select': '选择连接器',
  'admin.xtmCloud.llm.saved': '设置已保存。',
  'admin.xtmCloud.llm.error': '无法保存设置。',
  'admin.xtmCloud.llm.loadError': '无法加载连接器。',
  'admin.xtmCloud.llm.loading': '正在加载连接器…',
  'admin.xtmCloud.llm.unavailable': '不可用的连接器',
  'admin.xtmCloud.llm.missing': '已保存的连接器不再可用，可能已被停用或删除。请选择其他连接器。',
  'admin.xtmCloud.llm.nav.problem': '已保存的 LLM 连接器不再可用',
'admin.xtmCloud.llm.translationMode': 'Translation mode',  'admin.xtmCloud.llm.mode.single': 'Single',  'admin.xtmCloud.llm.mode.batch': 'Batch',  'admin.xtmCloud.llm.batchSize': 'Batch size',  'admin.xtmCloud.llm.batchSize.hint': '每批 1–50 个文档',
  'translatedBatches.title': '已翻译文件',
  'translatedBatches.searchPlaceholder': '按文件名搜索…',
  'translatedBatches.loading': '正在加载批次…',
  'translatedBatches.error': '无法加载已翻译批次。',
  'translatedBatches.empty': '未找到批次。',
  'translatedBatches.downloadAll': '全部下载',
  'translatedBatches.openInXtm': '在 XTM Cloud 中打开',
  'translatedBatches.filesLoading': '正在加载文件…',
  'translatedBatches.filesError': '无法加载此批次的文件。',
  'translatedBatches.noFiles': '此批次中没有已翻译文件。',
  'translatedBatches.prev': '上一页',
  'translatedBatches.next': '下一页',
  'translatedBatches.pageOf': '第 {current} 页，共 {total} 页',
  'translatedBatches.count': '{count, plural, other {# 个批次}}',
  'translatedBatches.fileCount': '{count, plural, other {# 个文件}}',
  'translatedBatches.fileMeta': '{language} · 来自 {source}',
  'translatedBatches.moreLanguages': '+{count}',
  'translatedBatches.expand': '显示已翻译文件',
  'translatedBatches.collapse': '隐藏已翻译文件',
  'translatedBatches.download': '下载',
  'translatedBatches.downloading': '正在下载…',
  'translatedBatches.downloadFile': '下载 {filename}',
  'translatedBatches.zipping': '正在准备 ZIP…',
  'translatedBatches.status.inProgress': '进行中',
  'translatedBatches.status.failed': '失败',
  'translatedBatches.status.expired': '已过期',
  'translatedBatches.moreFiles': '+{count}',
  'translatedBatches.readyOf': '{total} 个中已完成 {ready} 个',
  'translatedBatches.state.translating': '翻译中',
  'translatedBatches.state.inXtmCloud': '译员处理中',
  'translatedBatches.state.inXtmCloud.tooltip': 'XTM Cloud 中的译员正在翻译此文件。可能需要数天时间，完成后将通过电子邮件通知您。',
  'translatedBatches.state.unavailable': '仅在 XTM Cloud 中',
  'translatedBatches.state.unavailable.tooltip': '翻译已完成，但文件无法取回到 XTM Go。请打开 XTM Cloud 项目领取。',
  'translatedBatches.state.failed': '失败',
  'translatedBatches.noResults': '没有与“{query}”匹配的结果。',
  'translatedBatches.noResultsHint': '请尝试其他文件名。',
  'translatedBatches.emptyHint': '您翻译的文件将显示在这里。',
  'translatedBatches.clearSearch': '清除搜索',
  'translatedBatches.pagination': '分页',
  'translatedBatches.single.title': '已翻译批次',
  'translatedBatches.single.backToAll': '所有已翻译文件',
  'translatedBatches.single.notFound': '此批次不存在，或您无权查看。',
  'translatedBatches.single.notFoundHint': '请检查链接，或打开您的全部已翻译文件。',
  'translatedBatches.single.error': '无法加载此批次。',
  'admin.styleGuides.title': '风格指南',
  'admin.styleGuides.nav.problem': '默认风格指南已不存在',
  'admin.styleGuides.description': 'XTM Go 与 XTM Cloud 及其他 XTM 产品共享风格指南，因此在此所做的任何编辑或删除都会应用到所有地方。不过，您在下方选择的默认项仅适用于 XTM Go 中的 AI-Direct 通道。',
  'admin.styleGuides.summary.using': 'AI-Direct 翻译默认使用 {name}。',
  'admin.styleGuides.summary.none': '没有默认风格指南。AI-Direct 翻译在没有风格指南的情况下运行。',
  'admin.styleGuides.create': '新建风格指南',
  'admin.styleGuides.edit': '编辑 {name}',
  'admin.styleGuides.delete': '删除 {name}',
  'admin.styleGuides.action.edit': '编辑',
  'admin.styleGuides.action.delete': '删除',
  'admin.styleGuides.action.useNoDefault': '不使用风格指南',
  'admin.styleGuides.delete.title': '删除 {name}？',
  'admin.styleGuides.delete.body': '此操作将为所有用户永久删除 {name}，包括 XTM Cloud 在内的所有使用位置。',
  'admin.styleGuides.delete.bodySelected': '此操作将为所有用户永久删除 {name}，包括 XTM Cloud 在内的所有使用位置。这是默认风格指南，因此在您选择其他默认项或“不使用风格指南”之前，AI-Direct 翻译将失败。',
  'admin.styleGuides.delete.confirm': '删除',
  'admin.styleGuides.delete.cancel': '取消',
  'admin.styleGuides.delete.error': '无法删除 {name}。未做任何更改。',
  'admin.styleGuides.delete.busy': '目前无法删除 {name}。请稍后再试。',
  'admin.styleGuides.loadError': '无法读取贵组织的风格指南。这是读取问题，并不表示您没有风格指南；您的默认风格指南未更改。',
  'admin.styleGuides.retry': '重试',
  'admin.styleGuides.loadFailedUseNone.hint': '在风格指南无法加载期间，您可以移除默认风格指南，使 AI-Direct 翻译恢复正常。',
  'admin.styleGuides.loadFailedUseNone.done': '当前没有默认风格指南。AI-Direct 翻译在没有风格指南的情况下运行。',
  'admin.styleGuides.noLanguages': '无语言分区',
  'admin.styleGuides.saveError': '保存失败。默认仍为 {previous}。',
  'admin.styleGuides.saveErrorUnchanged': '保存失败。您的默认风格指南未更改。',
  'admin.styleGuides.noDefault': '不使用风格指南',
  'admin.styleGuides.noDefault.description': 'AI-Direct 翻译在没有风格指南的情况下运行。',
  'admin.styleGuides.notUsedByXtmGo': 'XTM Go 不使用',
  'admin.styleGuides.warning.missing': '{name} 曾是默认风格指南，但它已不存在（于 {date} 发现）。在您选择其他默认项或“不使用风格指南”之前，AI-Direct 翻译将失败。',
  'admin.styleGuides.column.name': '名称',
  'admin.styleGuides.column.languages': '语言',
  'admin.styleGuides.column.updated': '更新时间',
  'admin.styleGuides.column.default': '默认',
  'admin.styleGuides.column.actions': '操作',
  'admin.styleGuides.default.checked': '默认',
  'admin.styleGuides.default.unchecked': '设为默认',
  'admin.styleGuides.default.noneSr': '无风格指南',
  'admin.styleGuides.editor.loading': '正在打开风格指南编辑器…',
  'admin.styleGuides.editor.loadError': '无法加载风格指南编辑器。您的风格指南没有变化。',
  'admin.styleGuides.editor.back': '返回风格指南',
  'admin.styleGuides.editor.authOrganization': '尚未配置贵组织的风格指南身份。请在 XTM Cloud 连接设置中设置 XTM Cloud 客户端。',
  'admin.styleGuides.editor.authForbidden': '您已无权编辑风格指南。',
  'admin.styleGuides.editor.authFailed': '您的编辑会话已结束。请重新打开编辑器继续；未保存的更改会保留到您离开为止。',
  'admin.styleGuides.editor.unavailable': '此风格指南不可用。',
  'admin.styleGuides.editor.navigationNote': '如果通过切换部分或返回离开，未保存的更改将会丢失。请在编辑器中使用“取消”或“保存”。',

  // ── Language issues (COPA-877, COPA-878): draft, needs translation review ──
  'languageIssue.FILE_NOT_CREATED': '{language}：无法创建译文文件。',
  'languageIssue.FILE_NOT_CREATED_IN_TIME': '{language}：未能及时创建译文文件。',
  'languageIssue.TOO_MUCH_UNTRANSLATED': '{language}：有过多文本无法翻译。',
  'languageIssue.CONNECTOR_STALLED': '{language}：您的 LLM 连接器在 AI-Direct 通道上停止响应。',
  'languageIssue.CONNECTOR_UNAVAILABLE': '{language}：AI-Direct 通道无法连接到您的 LLM 连接器。',
  'languageIssue.STYLE_GUIDE_UNAVAILABLE': '{language}：无法加载贵组织的风格指南。请重试，或将文件发送到 XTM Cloud。',
  'languageIssue.STYLE_GUIDE_DELETED': '{language}：贵组织的风格指南已被删除。请让管理员选择其他选项，或将文件发送到 XTM Cloud。',
  'languageIssue.STYLE_GUIDE_NOT_CONFIGURED': '{language}：由于连接尚未设置，XTM Go 无法访问贵组织的风格指南。请让管理员检查 XTM Cloud 连接，或将文件发送到 XTM Cloud。',
  'languageIssue.STYLE_GUIDE_FILE_UNAVAILABLE': '{language}：无法加载为此文件选择的风格指南。请重试，或将文件发送到 XTM Cloud。',
  'languageIssue.STYLE_GUIDE_FILE_DELETED': '{language}：为此文件选择的风格指南已被删除。请重新上传文件，或将其发送到 XTM Cloud。',
  'languageIssue.DELIVERED_WITH_UNTRANSLATED': '{language}：由于您的 LLM 连接器停止响应，交付的文件中有 {untranslatedSegments, plural, one {# 个句段} other {# 个句段}}仍为源语言。',
  'languageIssue.STOPPED_UNEXPECTEDLY': '{language}：翻译意外停止。请重试。',
  'languageIssue.CONNECTOR_NOT_CONFIGURED': '{language}：贵组织尚未设置 LLM 连接器。请让管理员设置一个，或将文件发送到 XTM Cloud。',
  'languageIssue.UNSUPPORTED_STRUCTURE': '{language}：不支持此文件的结构。请将文件发送到 XTM Cloud。',
  'languageIssue.SOURCE_FILE_MISSING': '{language}：翻译所需的文件已不可用。请重新上传文件。',
  'languageIssue.PARSED_DOCUMENT_UNREADABLE': '{language}：无法创建译文文件。请重新上传文件。',
  'languageIssue.UPLOADED_BEFORE_UPDATE': '{language}：请重新上传文件；该文件是在更新之前上传的。',
  'languageIssue.SOURCE_LANGUAGE_NO_CONNECTOR': '{language}：由于未设置 LLM 连接器，无法检测源语言。请让管理员设置一个。',
  'languageIssue.SOURCE_LANGUAGE_CONNECTOR_FAILED': '{language}：由于您的 LLM 连接器没有响应，无法检测源语言。请重试。',
  'languageIssue.XTM_CLOUD_CONNECTION': '{language}：XTM Go 无法连接到 XTM Cloud。请让管理员检查 XTM Cloud 连接。',
  'languageIssue.XTM_CLOUD_UNSUPPORTED_FORMAT': '{language}：XTM Cloud 不支持此文件格式。',
  'languageIssue.XTM_CLOUD_PASSWORD_PROTECTED': '{language}：XTM Cloud 拒绝了该文件；文件可能受密码保护。',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE': '{language}：文件超出 XTM Cloud 可接受的大小（上限：{limit}）。',
  'languageIssue.XTM_CLOUD_FILE_TOO_LARGE_NO_LIMIT': '{language}：文件超出 XTM Cloud 可接受的大小。',
  'languageIssue.XTM_CLOUD_PROJECT_REFUSED': '{language}：XTM Cloud 拒绝了该项目。请重试。',
  'languageIssue.XTM_CLOUD_PROJECT_MAY_EXIST': '{language}：XTM Cloud 项目（“{projectName}”）可能已存在。请先在 XTM Cloud 中检查，再重试。',
  'languageIssue.XTM_CLOUD_HANDOVER_FAILED': '{language}：无法将文件发送到 XTM Cloud。请重试。',
  'languageIssue.XTM_CLOUD_TARGET_NOT_RETRIEVED': '{language}：无法从 XTM Cloud 获取译文文件。',
  'languageIssue.XTM_CLOUD_CUSTOMER_UNAVAILABLE': '{language}：为此文件选择的 XTM Cloud 客户已不可用。请使用其他客户重新决定该文件，或将其发送到 AI-Direct。',
  'languageIssue.XTM_CLOUD_TEMPLATE_UNAVAILABLE': '{language}：为此文件选择的项目模板在 XTM Cloud 中已不可用。请使用其他模板重新决定该文件，或将其发送到 AI-Direct。',
  'languageIssue.XTM_CLOUD_DEFAULT_CUSTOMER_UNAVAILABLE': '{language}：贵组织的 XTM Cloud 客户已不可用。请让管理员选择其他客户，或将文件发送到 AI-Direct。',
  'languageIssue.XTM_CLOUD_DEFAULT_TEMPLATE_UNAVAILABLE': '{language}：贵组织的项目模板在 XTM Cloud 中已不可用。请让管理员选择其他模板，或将文件发送到 AI-Direct。',
  'languageIssue.UNKNOWN_FAILURE': '{language}：翻译意外停止。请重试。',
  'languageIssue.UNKNOWN_WARNING': '{language}：已交付，但有警告。',
  'languageIssue.reference': '参考编号：{uploadBatchId}',
  'languageIssue.copyReference': '复制参考编号',
};

export default zh;
